<template>
  <div>
    <div class="table_th">
      <div style="width:15%">
        {{ $t(`lang.str_BombHeight`) }}
      </div>
      <div style="width:15%">
        {{ BombHeight }}x
      </div>
      <div style="width:15%">
      </div>
    </div>
    <div class="table_tr">
      <div style="width:15%">
        {{ $t(`lang.str_bet`) }}
      </div>
      <div style="width:15%">
        {{ $t(`lang.str_parachutemoney`) }}
      </div>
      <div style="width:15%">
        {{ $t(`lang.str_parachutehigh`) }}
      </div>
    </div>
    <div v-for="(item, index) in betInfos" :key="index">
      <div class="table_tr">
        <div style="width:15%">
          <div>{{ (item.Bet/100).toFixed(2) }}</div>
        </div>
        <div style="width:15%">
          <div>{{ (item.Win/100).toFixed(2)  }}</div>
        </div>
        <div style="width:15%">
          <div> {{ item.JumpPoint }}x</div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">
    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3000",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    betInfos:null,
    BombHeight:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3000.vue